import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSliderModule } from '@angular/material/slider'
// shared modules
import { SharedModule } from '../shared/shared.module';
// containers
import { BookingSectionComponent } from './containers/booking-section/booking-section.component';
import { StepLocationComponent } from './containers/step-location/step-location.component';
import { StepPaymentComponent } from './containers/step-payment/step-payment.component';
import { StepTimeComponent } from './containers/step-time/step-time.component';
// components
import { ResidentialComponent } from './components/location/residential/residential.component';
import { HotelBusinessComponent } from './components/location/hotel-business/hotel-business.component';
import { AirportComponent } from './components/location/airport/airport.component';
import { TimeslotsComponent } from './components/timeslots/timeslots.component';
import { BookerFormComponent } from './components/payment/booker-form/booker-form.component';
import { StandardPaymentComponent } from './components/payment/standard-payment/standard-payment.component';
import { RecurringPaymentComponent } from './components/payment/recurring-payment/recurring-payment.component';
import { D2dBookingSwitchComponent } from './components/d2d-booking-switch/d2d-booking-switch.component';
import { UpsellBookingComponent } from './components/upsell-booking/upsell-booking.component';
import { GooglePayComponent } from './components/payment/google-pay/google-pay.component';
import { ApplePayComponent } from './components/payment/apple-pay/apple-pay.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { SubsidyComponent } from './components/subsidy/subsidy/subsidy.component';
import { MilesAndMorePayComponent } from './components/payment/miles-and-more-pay/miles-and-more-pay.component';
import { HubdropTimeslotsComponent } from './components/hubdrop-timeslots/hubdrop-timeslots.component';
import { StepHubDropComponent } from './containers/step-hub-drop/step-hub-drop.component';
// external modules
import { MomentModule } from 'ngx-moment';
// google maps
// import { AgmCoreModule } from '@agm/core';
// routing
import { BookingRoutingModule } from './booking-section.routing';
import { BillingAddressComponent } from './components/payment/billing-address/billing-address.component';


export function importItems() {
  return [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BookingRoutingModule,
    SharedModule,
    MomentModule,
    // AgmCoreModule,
    GooglePayButtonModule,
    NgSelectModule,
    MatSliderModule
  ];
}

export function declarationItems() {
  return [
    BookingSectionComponent,
    StepLocationComponent,
    StepTimeComponent,
    StepPaymentComponent,
    ResidentialComponent,
    HotelBusinessComponent,
    AirportComponent,
    TimeslotsComponent,
    BookerFormComponent,
    StandardPaymentComponent,
    SubsidyComponent,
    RecurringPaymentComponent,
    D2dBookingSwitchComponent,
    GooglePayComponent,
    ApplePayComponent,
    BillingAddressComponent,
    UpsellBookingComponent,
    MilesAndMorePayComponent,
    StepHubDropComponent,
    HubdropTimeslotsComponent
  ];
}

@NgModule({
  imports: importItems(),
  declarations: declarationItems()
})
export class BookingSectionModule { }
